import { tokens } from '@companycam/slab';

const COLLAB_COLOR_VALUES = Object.freeze({
  purple: tokens.color_collab_purple,
  orange: tokens.color_collab_orange,
  green: tokens.color_collab_green,
  blue: tokens.color_collab_blue,
  red: tokens.color_collab_red,
  yellow: tokens.color_collab_yellow,
  navy: tokens.color_collab_navy,
  plum: tokens.color_collab_plum,
  magenta: tokens.color_collab_magenta,
  brown: tokens.color_collab_brown,
  owner: tokens.color_collab_owner,
});

const COLLAB_COLOR_NAMES = Object.keys(COLLAB_COLOR_VALUES);

const getCollabColorValue = (colorEnum) =>
  COLLAB_COLOR_VALUES[colorEnum] || tokens.color_brand_secondary;

export { COLLAB_COLOR_NAMES, getCollabColorValue };
